import {ReactNode} from "react";
import styles from './EditorActionsContainer.module.css'

const EditorActionsContainer = (props: {children: ReactNode | ReactNode[]}) => {
    return <div className={styles.action_container}>
        { props.children }
    </div>
}

export {EditorActionsContainer}